import React, { useState, useEffect } from 'react';
import { useWeb3 } from '../../contexts/Web3Context';
import { useUI } from '../../contexts/UIContext';
import { ethers } from 'ethers';

const LevelStructure = () => {
  const { userId, grichInvContract, shortenAddress } = useWeb3();
  const { currentLevel, setCurrentLevel, showLoading, hideLoading, showModal } = useUI();
  const [levelMembers, setLevelMembers] = useState([]);
  const [levelStats, setLevelStats] = useState({
    memberCount: 0,
    levelBusiness: '0',
    commissionRate: 10,
    totalEarnings: '0'
  });

  // Available levels
  const levels = [
    { value: 1, label: 'Level 1 (10%)' },
    { value: 2, label: 'Level 2 (10%)' },
    { value: 3, label: 'Level 3 (10%)' },
    { value: 4, label: 'Level 4 (10%)' },
    { value: 5, label: 'Level 5 (10%)' },
    { value: 6, label: 'Level 6 (10%)' }
  ];

  // Load level data when level changes
  useEffect(() => {
    if (userId > 0 && grichInvContract) {
      loadLevelData();
    }
  }, [userId, grichInvContract, currentLevel]);

  const loadLevelData = async () => {
    try {
      showLoading(`Loading level ${currentLevel} data...`);
      
      // Get level income details
      const levelDetails = await grichInvContract.getLevelIncomeDetails(userId, currentLevel - 1); // Level is 0-indexed in contract
      
      // Update stats
      setLevelStats({
        memberCount: parseInt(levelDetails.memberCount.toString()),
        levelBusiness: levelDetails.levelBusiness.toString(),
        commissionRate: parseInt(levelDetails.commissionRate.toString()),
        totalEarnings: levelDetails.totalEarnings.toString()
      });
      
      // Get members info if there are any
      if (levelDetails.memberCount.toNumber() > 0) {
        const membersInfo = await grichInvContract.getUserLevelusersInfo(userId, currentLevel - 1);
        setLevelMembers(membersInfo);
      } else {
        setLevelMembers([]);
      }
      
      hideLoading();
    } catch (error) {
      console.error(`Error loading level ${currentLevel} data:`, error);
      hideLoading();
      showModal('Error', `Failed to load level ${currentLevel} data. Please try again.`);
    }
  };

  // Handle level change
  const handleLevelChange = (e) => {
    setCurrentLevel(parseInt(e.target.value));
  };

  // Format a BigNumber as USDT with 2 decimal places
  const formatUSDT = (amount) => {
    return `${parseFloat(ethers.utils.formatUnits(amount, 18)).toFixed(2)} USDT`;
  };

  return (
    <div className="team-tab-content active" id="levels">
      <div className="level-selector">
        <label htmlFor="levelSelect">Select Level:</label>
        <select 
          id="levelSelect" 
          value={currentLevel}
          onChange={handleLevelChange}
        >
          {levels.map((level) => (
            <option key={level.value} value={level.value}>
              {level.label}
            </option>
          ))}
        </select>
      </div>
      
      <div className="level-metrics">
        <div className="level-metric">
          <div className="metric-value">{levelStats.memberCount}</div>
          <div className="metric-label">Members</div>
        </div>
        <div className="level-metric">
          <div className="metric-value">{formatUSDT(levelStats.levelBusiness)}</div>
          <div className="metric-label">Business Volume</div>
        </div>
        <div className="level-metric">
          <div className="metric-value">{formatUSDT(levelStats.totalEarnings)}</div>
          <div className="metric-label">Earnings</div>
        </div>
      </div>
      
      <div className="team-table-container">
        <table className="team-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Wallet</th>
              <th>Investment</th>
              <th>Upline ID</th>
            </tr>
          </thead>
          <tbody>
            {levelMembers.length > 0 ? (
              levelMembers.map((member, index) => (
                <tr key={index}>
                  <td>{parseInt(member.id.toString())}</td>
                  <td>{shortenAddress(member.acct)}</td>
                  <td>{formatUSDT(member.totalDepositUSDT)}</td>
                  <td>{parseInt(member.upline.toString()) === 0 ? '-' : parseInt(member.upline.toString())}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" style={{ textAlign: 'center' }}>No members in level {currentLevel} yet</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LevelStructure;
